import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import api from "../../services/api";
import {ReqAddEorInvoice, ReqSetEmployeePaid, ReqUpdatePayroll} from "../interfaces";
import {showUserFeedback} from "../userFeedback/actions";
import i18next from "../../lang/i18n";
import {
    API_END_POINT_ADD_EOR_INVOICE,
    API_END_POINT_EMPLOYEE,
    API_END_POINT_PAYROLL,
    API_END_POINT_PAYROLLS, API_END_POINT_SET_EMPLOYEE_PAID,
    API_END_POINT_UPDATE
} from "../../utils/constants";

export const fetchPayrolls = createAsyncThunk('payrolls', async () => {
    const response = await api.get(API_END_POINT_PAYROLLS);
    return response.data;
});

export const updatePayroll = createAsyncThunk('update_payroll', async (data: ReqUpdatePayroll, thunkAPI) => {
    try{
        const response = await api.put(`${API_END_POINT_UPDATE}${API_END_POINT_PAYROLL}/${data.payrollId}${API_END_POINT_EMPLOYEE}/${data.employeeId}`, data);
        thunkAPI.dispatch(showUserFeedback({
            type: 'success',
            title: i18next.t('payroll_successfully_updated_title'),
            message: i18next.t('payroll_successfully_updated_message')
        }))
        return response.data;
    }catch (error:any){
        thunkAPI.dispatch(showUserFeedback({
            type: 'error',
            title: i18next.t('error_message_title'),
            message: error.response?.data?.message || i18next.t('error_updating_payroll')
        }))
        throw error;
    }
});

export const addEorInvoiceDetails = createAsyncThunk('add_eor_invoice', async (data: ReqAddEorInvoice, thunkAPI) => {
    try {
        const response = await api.put(`${API_END_POINT_ADD_EOR_INVOICE}${API_END_POINT_PAYROLL}/${data.payrollId}${API_END_POINT_EMPLOYEE}/${data.employeeId}`, data);
        thunkAPI.dispatch(showUserFeedback({
            type: 'success',
            title: i18next.t('eor_invoice_successfully_uploaded_title'),
            message: i18next.t('eor_invoice_successfully_uploaded_message')
        }))
        return response.data;
    } catch (error: any) {
        thunkAPI.dispatch(showUserFeedback({
            type: 'error',
            title: i18next.t('error_message_title'),
            message: error.response?.data?.message || i18next.t('error_adding_invoice_details')
        }))
        throw error;
    }
});

export const setEmployeePaid = createAsyncThunk('set_employee_paid', async (data: ReqSetEmployeePaid, thunkAPI) => {
    try {
        const response = await api.put(`${API_END_POINT_SET_EMPLOYEE_PAID}${API_END_POINT_PAYROLL}/${data.payrollId}${API_END_POINT_EMPLOYEE}/${data.employeeId}`);
        thunkAPI.dispatch(showUserFeedback({
            type: 'success',
            title: i18next.t('employee_successfully_set_as_paid_title'),
            message: i18next.t('employee_successfully_set_as_paid_message')
        }))
        return response.data;
    } catch (error: any) {
        thunkAPI.dispatch(showUserFeedback({
            type: 'error',
            title: i18next.t('error_message_title'),
            message: error.response?.data?.message || i18next.t('error_setting_employee_paid')
        }))
        throw error;
    }
});


export const resetPayrollsUpdateStatus = createAction('reset_payrolls_update_status');
